var Handlebars = require("../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "mobile";
},"3":function(container,depth0,helpers,partials,data) {
    return "web";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"modalWrapper overlay nodrag "
    + ((stack1 = __default(require("../../../../../../../src/utils/handlebars-helpers/Mobile.js")).call(alias1,{"name":"Mobile","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":40},"end":{"line":1,"column":68}}})) != null ? stack1 : "")
    + ((stack1 = __default(require("../../../../../../../src/utils/handlebars-helpers/Desktop.js")).call(alias1,{"name":"Desktop","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":68},"end":{"line":1,"column":95}}})) != null ? stack1 : "")
    + "\" data-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\"></div>\n";
},"useData":true});